<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-9 ps-5">
                <h2 class="col pb-2 title">
                    {{ "METERTIMESYNC" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "METERTIMESYNC_SUBTITLE" | translate }}</h6>
            </div>
          <div class="col-md-3 d-flex justify-content-end align-items-center pe-5">
            @if (
              authService.isAuthorized([PermissionEnum.Report_meter_time_sync_download])
              ) {
                  <button class="col-auto add justify-content-center" (click)="download()">
                    {{ "DOWNLOAD" | translate }}
                  </button>
            }
          </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
                <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
                <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)"></app-search>
                <div class="button-wrapper-gray m-2">
                    <div class="button" (click)="reloadTable()" title="Reload table">
                        <div><img alt="Refresh" src="assets/device/refresh.svg" /></div>
                    </div>
                </div>
            </div>
            <div class="row g-0 m-0 pt-3">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "ENERGYREGISTERS_METERNO" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_METERMAKE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "SYNCSTATUS" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DIFFERENCE" | translate }}</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data">
                            <td></td>
                            <td>
                                <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event)"
                                    class="copyable">
                                    {{ row.meterNumber }}
                                    <span class="copy-tooltip"
                                        *ngIf="clipboardService.copiedText === row.meterNumber">{{"COPIED" |
                                        translate}}</span>
                                </span>
                            </td>
                            <td>
                                <span>{{row.meterMakeName}}</span>
                            </td>
                            <td>
                                <span class="text-wrapper"
                                    [ngClass]="row.meterTimeDifference != null && (row.meterTimeDifference! | abs) <= row.allowedClockOffsetInSeconds! ? 'status-completed' : 'status-failed'">
                                    {{ (row.meterTimeDifference != null && (row.meterTimeDifference! | abs) <=
                                        row.allowedClockOffsetInSeconds! ? 'INSYNC' : 'OUTOFSYNC' ) | translate
                                        }}</span>
                            </td>
                            <td>
                                <span>{{ row.meterTimeDifference !== null && row.meterTimeDifference !== undefined
                                    ? (row.meterTimeDifference | secondsToText)
                                    : 'No value'}}</span>
                            </td>
                            <td class="centered">
                                @if(authService.isAuthorized([PermissionEnum.Report_meter_time_sync_execute]) &&
                                (row.meterTimeDifference == null || (row.meterTimeDifference! | abs) >
                                row.allowedClockOffsetInSeconds!)) {
                                    <span (click)="rowClick(row.meterId!)">
                                        <span [class.rotating]="row?.commandStatus === CommandStatus.Pending" class="icon-wrapper">
                                            <svg-icon
                                                alt="Sync"
                                                class="hover-effect"
                                                [src]="row?.commandStatus === CommandStatus.Pending ? 'assets/syncing.svg' : 'assets/sync.svg'">
                                            </svg-icon>
                                        </span>
                                        <span [class.pending]="row?.commandStatus === CommandStatus.Pending" class="in-sync">{{ (row?.commandStatus == CommandStatus.Pending ? "SYNCING" : "SYNC") | translate }}</span>
                                    </span>
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfItems" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
</div>
